"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_number_1 = require("./is-number");
var isInteger = Number.isInteger ? Number.isInteger : function (num) {
    return is_number_1.default(num) && num % 1 === 0;
};
exports.default = isInteger;
//# sourceMappingURL=is-integer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-integer.js
// module id = 1120
// module chunks = 37